import React, { useRef, useState } from 'react'
// import travellingImg from "../../assets/images.png";
// import estateImg from "../../assets/real.png";
// import posImg from "../../assets/pos1.jpg";
import { ProjectData } from '../../util/ProjectData';
const Backendproject = () => {
const [isOpen, setIsOpen] = useState(false);
const [selectedProject, setSelectedProject] = useState(null);

const openModal = (project) => {
setSelectedProject(project);
setIsOpen(true);
};

const closeModal = () => {
setIsOpen(false);
setSelectedProject(null);
};
const handleMouseMove = (e) => {
    const card = e.currentTarget;
    const rect = card.getBoundingClientRect();

    const x = e.clientX - rect.left;
    const y = e.clientY - rect.top;

    card.style.setProperty("--x", `${x}px`);
    card.style.setProperty("--y", `${y}px`);

    const centerX = rect.width / 2;
    const centerY = rect.height / 2;

    const rotateX = (y - centerY) / 18;
    const rotateY = (centerX - x) / 18;

    card.style.transform = `
      perspective(1000px)
      rotateX(${rotateX}deg)
      rotateY(${rotateY}deg)
      scale(1.03)
    `;
  };

  const handleMouseLeave = (e) => {
    const card = e.currentTarget;
    card.style.transform =
      "perspective(1000px) rotateX(0deg) rotateY(0deg) scale(1)";
  };
return (
<div className="projects-content">


    {
    ProjectData().map((project) => (
    <div onMouseMove={handleMouseMove}
          onMouseLeave={handleMouseLeave}
          className="
            relative h-[420px] group rounded-2xl
            bg-zinc-900 text-white
            p-6 overflow-hidden
            transition-transform duration-300 project-card
          "  key={project.id}     
          style={{
          
            borderColor:"absolute inset-0 rounded-2xl border border-white/10 group-hover:border-indigo-400/40 transition"
        }}
          >
             {/* <div className="image-wrapper"> */}
    {/* <img src={project.img} alt={project.title}  className='image-wrapper'/> */}
  {/* </div> */}
        {/* <img
  src={project.img}
  alt=""
  className={`project-img ${project.id === 1 ? "project-img-large" : ""}`}
/> */}
<img
  src={project.img}
  alt=""
  className={`project-img ${project.id === 1 ? "project-img" : ""}`}
/>

        <h3 className="project-title">
            {project.title}
        </h3>
        <span className="project-detail">
            {/* {project.detail} */}
        </span>
        <div className="project-icon">
          {(project.id === 1 || project.id === 2 || project.id === 4 || project.id === 3) ? ('') : (
  <a
    href={project.source ? project.source : ''}
    className="project-button"
  >
    Source Code{" "}
    <i className="uil uil-github-alt project-card-icon"></i>
  </a>
)}

           


           <button 
              className="project-button-seemore seemoreAnimation " 
              onClick={() => openModal(project)}
            >
              See More{" "}
              {/* <i className="bx bx-up-arrow-alt project-card-icon"></i> */}
            </button>


        </div>
    </div>
    ))
    }

    {isOpen && (
    <div className="modal-overlay" onClick={closeModal}>
        <div className="modal-box" onClick={(e)=> e.stopPropagation()} // prevent overlay click from closing modal
            >
             <span className="modal-close" onClick={closeModal}>
        &times;
      </span>

      <img src={selectedProject.img} className="project-img" alt="" />
      <h3 className="modal-title">{selectedProject.title}</h3>

      {/* Default detail */}
      {/* <p className="modal-detail">{selectedProject.detail}</p> */}

      {/* Show See More Section */}
      {selectedProject.seeMore && (
        <div className="modal-seemore">
          {/* Summary */}
         <h4 className="font-semibold mb-2">
  {selectedProject.seeMore.roleTitle}
</h4>

<ol className=" text-gray-700 items-start">
  {selectedProject.seeMore.responsibilities.map((item, index) => (
    <li key={index}>{item}</li>
  ))}
</ol>

        </div>
      )}

     
      {selectedProject.source && (
              <a href={selectedProject.source} target="_blank" rel="noopener noreferrer" className="modal-button">
                View Source
              </a>
            )}
        </div>
    </div>
    )}


</div>
)
}

export default Backendproject
